import styled, { css } from "styled-components";

import { StyledQuillWrapperProps } from "./types";

export const QuillWrapper = styled.div<StyledQuillWrapperProps>`
  position: relative;

  .ql-editor {
    min-height: 200px;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      :before {
        cursor: not-allowed;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 1;
      }
    `};
`;
